import React from 'react'
import { formatTemplateName } from '../whatsapp/waTemplateUtils'

const WA = '#25D366'
const WA_DARK = '#128C7E'

// Created By Cursor — shared Use Template dialog (Compose / Fee Reminder)
export default function CommTemplatePickerDialog({
  serviceName,
  templates,
  selectedId,
  search,
  onSearch,
  onPick,
  onClose,
}) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.52)',
        backdropFilter: 'blur(4px)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          width: '100%',
          maxWidth: 820,
          maxHeight: '86vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 24px 64px rgba(15, 23, 42, 0.28)',
          overflow: 'hidden',
          border: '1px solid rgba(226, 232, 240, 0.9)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '16px 20px',
            background: `linear-gradient(120deg, ${WA_DARK} 0%, ${WA} 100%)`,
            color: '#fff',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <span
              style={{
                width: 40,
                height: 40,
                borderRadius: 11,
                background: 'rgba(255,255,255,0.2)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <i className="fa fa-file-text-o" style={{ fontSize: 16 }} aria-hidden />
            </span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 17, lineHeight: 1.2 }}>
                Choose template
              </div>
              <div style={{ fontSize: 12, opacity: 0.92, fontWeight: 600, marginTop: 3 }}>
                {serviceName} · {templates.length} available
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: '1px solid rgba(255,255,255,0.35)',
              background: 'rgba(0,0,0,0.15)',
              borderRadius: 10,
              width: 36,
              height: 36,
              cursor: 'pointer',
              fontWeight: 700,
              color: '#fff',
              fontSize: 18,
              lineHeight: 1,
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div
          style={{
            padding: '14px 20px',
            borderBottom: '1px solid #eef2f7',
            background: '#f8fafc',
          }}
        >
          <div style={{ position: 'relative' }}>
            <i
              className="fa fa-search"
              style={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#94a3b8',
                fontSize: 13,
              }}
              aria-hidden
            />
            <input
              type="search"
              className="form-control form-control-sm"
              placeholder="Search by name, category, or message body…"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              autoFocus
              style={{
                borderRadius: 10,
                paddingLeft: 34,
                height: 38,
                fontWeight: 600,
                border: '1px solid #e2e8f0',
              }}
            />
          </div>
        </div>

        <div
          style={{
            overflowY: 'auto',
            padding: '14px 16px 18px',
            flex: 1,
            background: '#f8fafc',
          }}
        >
          {templates.length === 0 ? (
            <div
              style={{
                padding: '40px 16px',
                textAlign: 'center',
                color: '#94a3b8',
                fontSize: 13,
                fontWeight: 600,
                background: '#fff',
                borderRadius: 12,
                border: '1px dashed #cbd5e1',
              }}
            >
              No templates found for this service
            </div>
          ) : (
            templates.map((t) => {
              const isSelected = String(selectedId) === String(t.id)
              const bodyText = t.body_text || t.body || t.message || ''
              const category = t.category || ''
              return (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => onPick(t)}
                  style={{
                    display: 'block',
                    width: '100%',
                    textAlign: 'left',
                    border: isSelected ? `2px solid ${WA}` : '1px solid #e2e8f0',
                    background: '#fff',
                    borderRadius: 14,
                    padding: '14px 16px',
                    marginBottom: 10,
                    cursor: 'pointer',
                    boxShadow: isSelected
                      ? '0 8px 22px rgba(37, 211, 102, 0.18)'
                      : '0 1px 3px rgba(15, 23, 42, 0.04)',
                    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 12,
                      alignItems: 'flex-start',
                      marginBottom: 10,
                    }}
                  >
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div
                        style={{
                          fontWeight: 800,
                          fontSize: 15,
                          color: '#0f172a',
                          lineHeight: 1.3,
                        }}
                      >
                        {formatTemplateName(t.name)}
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 6,
                          marginTop: 8,
                        }}
                      >
                        {category ? (
                          <span
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              fontSize: 11,
                              fontWeight: 800,
                              letterSpacing: '0.03em',
                              textTransform: 'uppercase',
                              color: '#0f766e',
                              background: '#ccfbf1',
                              borderRadius: 999,
                              padding: '3px 9px',
                            }}
                          >
                            {category}
                          </span>
                        ) : null}
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            fontSize: 11,
                            fontWeight: 700,
                            textTransform: 'capitalize',
                            color: t.status === 'approved' ? WA_DARK : '#64748b',
                            background:
                              t.status === 'approved' ? `${WA}18` : '#f1f5f9',
                            borderRadius: 999,
                            padding: '3px 9px',
                          }}
                        >
                          {t.status || '—'}
                        </span>
                        {t.group_name ? (
                          <span
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              fontSize: 11,
                              fontWeight: 600,
                              color: '#64748b',
                              background: '#f8fafc',
                              border: '1px solid #e2e8f0',
                              borderRadius: 999,
                              padding: '3px 9px',
                            }}
                          >
                            {t.group_name}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <span
                      style={{
                        flexShrink: 0,
                        fontSize: 12,
                        fontWeight: 800,
                        color: isSelected ? WA_DARK : '#94a3b8',
                        paddingTop: 2,
                      }}
                    >
                      {isSelected ? 'Selected' : 'Use'}
                    </span>
                  </div>

                  {bodyText ? (
                    <div
                      style={{
                        fontSize: 13,
                        color: '#334155',
                        lineHeight: 1.55,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        background: '#f8fafc',
                        border: '1px solid #eef2f7',
                        borderRadius: 10,
                        padding: '10px 12px',
                      }}
                    >
                      {bodyText}
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}>
                      No body text
                    </div>
                  )}
                </button>
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}
